import { _, helpers, ts } from '_core';

import { DraftParams } from './types';

export const formatSeriesName = (key: string, baskets: ts.types.basket.Basket[]) => {
  const currentBasket = baskets.find((b) => b.handle == key);
  if (currentBasket) return currentBasket.name;

  return key;
};

export const prepareLinearData = (
  localData: ts.types.widgets.TableData,
  basketId: number,
  basketIds: number[],
  baskets: ts.types.basket.Basket[] = []
) => {
  const newData = localData.map((el) => {
    const newRow = {
      date: el.date,
    } as ts.types.widgets.TableData[number];

    Object.keys(el).forEach((key) => {
      const formattedKey = formatSeriesName(key.split('-')[0], baskets);
      if (!key.includes('portfolio_returns')) newRow[formattedKey] = el[key];
    });

    if (basketIds.includes(basketId)) {
      basketIds.forEach((bid) => {
        const currentBasket = baskets?.find((basket) => basket.id === bid);
        if (currentBasket) newRow[currentBasket.name] = newRow[currentBasket.handle];
      });
    }
    return newRow;
  });

  return newData;
};

export const validate = (params: DraftParams) => helpers.validations.validBasketCompare(params);

export const formatData = (data: ts.types.widgets.TableData): ts.types.widgets.TableData => {
  const groupedData = _.groupBy(data, 'end_date');
  const series = new Set(data.map((item) => item.backtest_handle));

  return _.map(groupedData, (items, date) => {
    const formattedEntry: ts.types.widgets.TableData[number] = { date };

    series.forEach((serie) => {
      const item = items.find((i) => i.backtest_handle === serie);
      const backtest_handle = serie;

      const { benchmark_returns } = item ?? {};

      formattedEntry[`${backtest_handle}-benchmark_drawdown`] = benchmark_returns;
    });

    return formattedEntry;
  });
};
